export default "__VITE_ASSET__781e46c2__"